import {daemon, Service} from '@iiiristram/sagun'
import {call, put, select} from 'typed-redux-saga'

import {close} from './reducer'
import {ModalID} from './types'
import {getModalByID} from './utils'

export class ModalService extends Service {
  toString(): string {
    return 'Core/ModalService'
  }

  @daemon()
  *submit(modalID: ModalID, result: unknown) {
    const {submit} = yield* select(getModalByID(modalID))

    yield* call(submit, result)
  }

  @daemon()
  *close(modalID: ModalID) {
    yield* put(close(modalID))
  }
}
